/**
 * student/campaigns — API (service methods).
 * The only place that talks to the backend for this domain. Each method maps to
 * one endpoint and returns typed data (or throws ApiError) via the shared `http`.
 */
import { http } from '../../_shared/http';
import type {
  StudentCampaignSummary,
  StudentCampaignDetail,
  GameplayPostSessionContext,
  CompleteActivityResult,
  GameplayReflectionResult,
} from './types';

export const studentCampaignsApi = {
  listMine: () => http.get<StudentCampaignSummary[]>('/campaigns/my-campaigns'),

  get: (id: string) => http.get<StudentCampaignDetail>(`/campaigns/${id}`),

  getArticle: (campaignId: string, activityId: string) =>
    http.get<{ markdown: string }>(`/campaigns/${campaignId}/activities/${activityId}/article`),

  getMaterialArticle: (campaignId: string, materialId: string) =>
    http.get<{ markdown: string }>(`/campaigns/${campaignId}/materials/${materialId}/article`),

  complete: (campaignId: string, activityId: string, result?: Record<string, unknown>) =>
    http.post<CompleteActivityResult>(
      `/campaigns/${campaignId}/activities/${activityId}/complete`,
      { result },
    ),

  getGameplayContext: (campaignId: string, activityId: string) =>
    http.get<GameplayPostSessionContext>(
      `/campaigns/${campaignId}/activities/${activityId}/gameplay-context`,
    ),

  submitGameplayReflection: (
    campaignId: string,
    activityId: string,
    answers: Record<string, string>,
    endorsements: { nakamaId: string; tagId: string }[],
  ) =>
    http.post<GameplayReflectionResult>(
      `/campaigns/${campaignId}/activities/${activityId}/gameplay-reflection`,
      { answers, endorsements },
    ),
};
